import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hideComposicion, okButton, hideOperacion, showOrdenesPendientes } from '../redux/actions';
import { nWithCommas, getOrdenesPendientes, openTip, closeTip } from '../utils';
import M from 'materialize-css';

class OrdenesPendientes extends Component {

    state = {
        ordenesPendientes: false,
        operacionSeleccionada: false
    }

    async componentDidUpdate(prevProps, prevState) {

        M.Tooltip.init(document.querySelectorAll('.tooltipped'), {});

        if (this.props.showOrdenesPendientesFlag && !prevProps.showOrdenesPendientesFlag) {
            this.setOrdenesPendientes();
        }

    }

    componentDidMount() {

        M.Modal.init(document.querySelectorAll('.modal_opPendientes'), {
            onCloseStart: () => {
                this.setState({ operacionSeleccionada: false });
            }
        });
    }

    async setOrdenesPendientes() {
        //Muestra el modal de carga mientras responde el servicio
        openTip();
        let ordenesPendientes = null;
        try {
            ordenesPendientes = await getOrdenesPendientes(this.props.currentContrato.Contrato);
        } finally {
            closeTip();
        }

        if (!ordenesPendientes || !Object.keys(ordenesPendientes).length) {

            this.props.okButton({
                message: "Por el momento no se encontró información", title: "Ordenes Pendientes", txtButton: "Entendido",
                statusCode: 404
            });

        } else {
            this.setState({ ordenesPendientes });
            M.Modal.getInstance(document.getElementById('modal_opPendientes')).open();
        }

        this.props.showOrdenesPendientes(false);

    }



    render() {
        const operacionSeleccionada = this.state.operacionSeleccionada;
        return (
            <div id="modal_opPendientes" className={`modal modal_opPendientes`}>
                <div className="closeModalOk left-align">
                    <i className="material-icons cursorPointer" onClick={() => {

                        if (!operacionSeleccionada) {
                            M.Modal.getInstance(document.querySelectorAll('.modal_opPendientes')[0]).close();
                        } else {
                            this.setState({ operacionSeleccionada: false });
                        }


                    }}>chevron_left</i> <span className="titleModal">
                        {
                            operacionSeleccionada ? "Detalle de Operación" : " Operaciones Pendientes"
                        }

                    </span>
                </div>
                <div className="modal-content contentModalopPendientes">

                    {
                        operacionSeleccionada ?
                            <React.Fragment>
                                <div className="col s12 mt-1 detailCard" >
                                    <div className="row containerDetalleOpera">

                                        <div className="col s6">
                                            <p className="noMBottom ft-10">No. de Contrato</p>
                                            <p className={`noMTop`}>
                                                {operacionSeleccionada.Contrato}</p>
                                        </div>

                                        <div className="col s6">
                                            <p className="noMBottom ft-10">Folio</p>
                                            <p className={`noMTop `}>
                                                {operacionSeleccionada.Folio}</p>
                                        </div>

                                        <div className="col s6 bgGray">
                                            <p className="noMBottom ft-10">Emisora</p>
                                            <p className={`noMTop ${operacionSeleccionada.Emisora ? '' : 'txtGray'}`}>
                                                {operacionSeleccionada.Emisora ? operacionSeleccionada.Emisora : '_'}</p>
                                        </div>

                                        <div className="col s6 bgGray">
                                            <p className="noMBottom ft-10">Serie</p>
                                            <p className={`noMTop ${operacionSeleccionada.Serie ? '' : 'txtGray'}`}>
                                                {operacionSeleccionada.Serie ? operacionSeleccionada.Serie : '_'}</p>
                                        </div>

                                        <div className="col s6">
                                            <p className="noMBottom ft-10">Títulos</p>
                                            <p className={`noMTop`}>
                                                {operacionSeleccionada.Titulos}</p>
                                        </div>

                                        <div className="col s6">
                                            <p className="noMBottom ft-10">Tipo de Servicio</p>
                                            <p className={`noMTop `}>
                                                {operacionSeleccionada.TipoServicio}</p>
                                        </div>

                                        <div className="col s6 bgGray">
                                            <p className="noMBottom ft-10">Tipo de operación</p>
                                            <p className={`noMTop ${operacionSeleccionada.TipoOper ? '' : 'txtGray'}`}>
                                                {operacionSeleccionada.TipoOper ? operacionSeleccionada.TipoOper : '_'}</p>
                                        </div>

                                        <div className="col s6 bgGray">
                                            <p className="noMBottom ft-10">Mercado</p>
                                            <p className={`noMTop ${operacionSeleccionada.Mercado ? '' : 'txtGray'}`}>
                                                {operacionSeleccionada.Mercado ? operacionSeleccionada.Mercado : '_'}</p>
                                        </div>

                                        <div className="col s6">
                                            <p className="noMBottom ft-10">Importe</p>
                                            <p className={`noMTop ${operacionSeleccionada.Importe ? '' : 'txtGray'}`}>
                                                ${operacionSeleccionada.Importe ? nWithCommas(parseFloat(operacionSeleccionada.Importe).toFixed(2)) : '_'}</p>
                                        </div>

                                        <div className="col s6">
                                            <p className="noMBottom ft-10">IVA</p>
                                            <p className={`noMTop `}>
                                                ${operacionSeleccionada.IVA ? nWithCommas(parseFloat(operacionSeleccionada.IVA).toFixed(2)) : ""}</p>
                                        </div>

                                        <div className="col s6 bgGray">
                                            <p className="noMBottom ft-10">Comisión</p>
                                            <p className={`noMTop ${operacionSeleccionada.Comision ? '' : 'txtGray'}`}>
                                                ${operacionSeleccionada.Comision ? nWithCommas(parseFloat(operacionSeleccionada.Comision).toFixed(2)) : '_'}</p>
                                        </div>

                                        <div className="col s6 bgGray">
                                            <p className="noMBottom ft-10">Neto a liquidar</p>
                                            <p className={`noMTop ${operacionSeleccionada.NetoLiquidar ? '' : 'txtGray'}`}>
                                                ${operacionSeleccionada.NetoLiquidar ? nWithCommas(parseFloat(operacionSeleccionada.NetoLiquidar).toFixed(2)) : '_'}</p>
                                        </div>

                                        <div className="col s6">
                                            <p className="noMBottom ft-10">Fecha de operación</p>
                                            <p className={`noMTop`}>
                                                {operacionSeleccionada.FOper}</p>
                                        </div>

                                        <div className="col s6">
                                            <p className="noMBottom ft-10">Fecha de liquidación</p>
                                            <p className={`noMTop `}>
                                                {operacionSeleccionada.FLiq}</p>
                                        </div>

                                        <div className="col s6 bgGray">
                                            <p className="noMBottom ft-10">Fecha</p>
                                            <p className={`noMTop ${operacionSeleccionada.Fecha ? '' : 'txtGray'}`}>
                                                {operacionSeleccionada.Fecha ? operacionSeleccionada.Fecha : '_'}</p>
                                        </div>

                                        <div className="col s6 bgGray">
                                            <p className="noMBottom ft-10">Hora</p>
                                            <p className={`noMTop ${operacionSeleccionada.Hora ? '' : 'txtGray'}`}>
                                                {operacionSeleccionada.Hora ? operacionSeleccionada.Hora : '_'}</p>
                                        </div>



                                    </div>

                                    <div className='row mt-1'>
                                        <div className='col s12 ft-12'>
                                            Apreciable cliente recuerde que la única información oficial al respecto
                                            de su saldo, es la que usted recibe en su estao de cuenta.
                                        </div>
                                    </div>

                                    <div className='row mt-1'>
                                        <div className='col s12 center-align'>
                                                <button className="modal-close waves-effect btn primaryBtn">Aceptar</button>
                                        </div>
                                    </div>
                                </div>

                            </React.Fragment>
                            :
                            <React.Fragment>
                                <div className="row">
                                    <div className="col s12 left-align">
                                        <p>No. de Contrato {this.props.currentContrato ? this.props.currentContrato.Contrato : "300132"}</p>
                                    </div>

                                </div>
                                <div className="row">
                                    {
                                        this.getComposicionDos()
                                    }
                                </div>
                                  <div className='col s12'>
                                            <i className="material-icons left">info_outline</i>
                                            <span>Recuerde que esta sección muestra las compras o ventas con montos de títulos y saldos estimados</span>
                                    </div>
                                    <div className='col s12 mt-1'>
                                        
                                    </div>
                            </React.Fragment>
                    }



                </div>
            </div>
        )
    }

    getComposicionDos = () => {


        const tipoOperacion = Object.keys(this.state.ordenesPendientes);

        return tipoOperacion.map((tipo, index) => {

            const operaciones = this.state.ordenesPendientes[tipo];

            return (
                <div className="col s12" key={index}>
                    <div className="row">
                        <div className="col s12 left-align  bgSky white-text panding-5">{tipo}</div>

                        {
                            operaciones.map((op, idxOp) => {

                                return (
                                    <React.Fragment key={idxOp}>
                                        <div className="col s12 left-align  bgSub subText panding-5">{op.TipoServicio} <span style={{color:'black'}} className='right'>{op.FOper}</span></div>
                                        <div className="col s12">
                                            <div className="row mt-1 cursorPointer" onClick={() => {
                                                this.setState({ operacionSeleccionada: op });
                                            }}>
                                                <div className="col s6 left-align">{op.Emisora} - {op.Serie}</div>
                                                <div className="col s6 right-align">${op.Importe ? nWithCommas(parseFloat(op.Importe).toFixed(2).toString()) : '_'}</div>
                                                <div className="col s6 left-align txtBlackie ft-12">{op.Titulos} títulos estimados</div>
                                                <div className="col s6 right-align txtBlackie ft-12">Importe {op.NetoLiquidar}</div>
                                            </div>
                                            <div className="divider">
                                            </div>
                                        </div>
                                    </React.Fragment>

                                )
                            })
                        }
                    </div>
                </div>
            )
        });




    }

}

const mapStateToProps = state => {
    let { composicion } = false;
    let { dataUser, currentContrato, menuPerfil, contratosUser,
        chequera, history, saldoTotal, saldoLiquido
    } = false;
    let showOrdenesPendientesFlag = false;

    if (state.servicesActions) {
        dataUser = state.servicesActions.dataUser || false;
        currentContrato = state.servicesActions.currentContrato || false
        contratosUser = state.servicesActions.contratosUser || false
        chequera = state.servicesActions.chequera || false



    }

    if (state.commonsActions) {
        composicion = state.commonsActions.composicion || false;
        menuPerfil = state.commonsActions.menuPerfil || false;
        history = state.commonsActions.history || false;
        saldoTotal = state.commonsActions.saldoTotal || 0;
        saldoLiquido = state.commonsActions.saldoLiquido || false;
        showOrdenesPendientesFlag = state.commonsActions.showOrdenesPendientes || false;
    }

    return {
        composicion, dataUser, currentContrato, menuPerfil, contratosUser, chequera,
        history, saldoTotal, saldoLiquido, showOrdenesPendientesFlag
    };
};


export default connect(mapStateToProps, { hideComposicion, okButton, hideOperacion, showOrdenesPendientes })(OrdenesPendientes)